import { DataType } from "@soft-db/data-formatter";
import { createPluginOptions } from "../create-plugin-options";
import { DataStyle } from "../type";

export type EventBarEventOptions = {
	id: string;
	type: DataType;
	style: DataStyle;
};

export const defaultEventBarDataOptions = createPluginOptions()({
	events: [] as EventBarEventOptions[],
});

export type EventBarDataOptions = typeof defaultEventBarDataOptions;
